/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogStatus from 'layout/dialog/DialogStatus';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';
import Button from 'components/common/Button';

export default function RemoveUserErrorDialog({ errorDialog, onToggleErrorDialog, onSubmitErrorDialog }) {
  const { t } = useTranslation();

  return (
    <Dialog data-testid="delete-account-result-dialog" open={errorDialog.open} fullWidth maxWidth="md">
      <DialogTitle>
        <DialogStatus variant="error" />
        <Typography component="h3" variant="h3">
          {t('user.management.delete-account.error.dialog.title')}
        </Typography>
      </DialogTitle>
      <DialogContent>{t('user.management.delete-account.error.dialog.description')}</DialogContent>
      <DialogActions>
        <Button data-testid="cancel-btn" color="default" onClick={() => onToggleErrorDialog(false)}>
          {t('button.cancel.label')}
        </Button>
        <Button data-testid="go-to-user-btn" color="primary" onClick={onSubmitErrorDialog}>
          {t('user-management.go.to.org')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
